import React, { useState } from 'react'
import PropTypes from 'prop-types'
import { Button, Icon, Segment } from 'semantic-ui-react'
import { useAuth } from 'react-oidc-context'
import SessionCountdown from './SessionCountdown'

const UserProfile = ({ userContext }) => {
  const auth = useAuth()
  const [showDropdown, setShowDropdown] = useState(false)
  const globalRole = userContext?.globalRole
  const isStaffRole = globalRole === 'MANAGER' || globalRole === 'SYSTEM_ADMIN'

  const handleLogout = () => {
    auth.removeUser()
    window.location.href = window.location.origin + '/'
  }

  const toggleDropdown = () => {
    setShowDropdown(!showDropdown)
  }

  if (auth.isAuthenticated) {
    // console.log('auth.user', auth.user)

    return (
      <div
        style={{
          position: 'absolute',
          top: '10px',
          right: '10px',
          zIndex: 1000,
          display: 'flex',
          alignItems: 'center',
          gap: '10px',
        }}
      >
        <div style={{ position: 'relative' }}>
          <div
            onClick={toggleDropdown}
            style={{
              width: '40px',
              height: '40px',
              marginRight: '100px',
              borderRadius: '50%',
              backgroundColor: '#4a90e2',
              color: 'white',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              fontSize: '18px',
              fontWeight: 'bold',
              cursor: 'pointer',
            }}
          >
            {auth.user?.profile.email[0].toUpperCase()}
          </div>

          {showDropdown && (
            <div
              style={{
                position: 'absolute',
                top: '45px',
                right: '0',
                marginRight: '100px',
                paddingTop: '10px',
                backgroundColor: 'white',
                borderRadius: '4px',
                boxShadow: '0 2px 5px rgba(0,0,0,0.2)',
                padding: '1rem',
                minWidth: '200px',
              }}
            >
              <div style={{ marginBottom: '10px' }}>
                <strong>Email:</strong> {auth.user?.profile?.email}
              </div>
              {auth.user?.profile?.name && (
                <div style={{ marginBottom: '10px' }}>
                  <strong>Name:</strong> {auth.user?.profile?.name}
                </div>
              )}
              <div style={{ marginBottom: '10px' }}>
                <strong>ID:</strong> {auth.user?.profile?.sub?.substring(0, 10)}
                ...
              </div>
              {isStaffRole && (
                <div style={{ marginBottom: '10px' }}>
                  <strong>Role:</strong> {globalRole}
                </div>
              )}
              {auth.user?.expires_at && (
                <div style={{ marginBottom: '10px' }}>
                  <strong>Session expires in:</strong>{' '}
                  <SessionCountdown expiresAt={auth.user?.expires_at} />
                </div>
              )}
              {isStaffRole && (
                <div style={{ marginBottom: '10px' }}>
                  <a href="/admin">Open Admin</a>
                </div>
              )}

              <div style={{ borderTop: '1px solid #eee', paddingTop: '10px' }}>
                <Button
                  fluid
                  compact
                  onClick={handleLogout}
                  color="red"
                  size="small"
                >
                  <Icon name="sign-out" />
                  Sign Out
                </Button>
              </div>
            </div>
          )}
        </div>
      </div>
    )
  }

  return (
    <div
      style={{
        position: 'absolute',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%, -50%)',
        textAlign: 'center',
        zIndex: 1000,
      }}
    >
      <Segment
        padded="very"
        style={{ backgroundColor: 'rgba(255, 255, 255, 0.9)' }}
      >
        <div
          style={{
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
          }}
        >
          <a
            href="https://drivepoints.com/"
            target="_blank"
            rel="noopener noreferrer"
          >
            <div className="drivepoints-logo" />
          </a>
        </div>
        <h2>Welcome to Drivepoints</h2>
        <p
          style={{
            marginTop: '0.75rem',
            maxWidth: '260px',
            fontSize: '0.85rem',
            lineHeight: 1.4,
            marginLeft: 'auto',
            marginRight: 'auto',
          }}
        >
          By signing in and using the app, you agree to our{' '}
          <a
            href="https://drivepoints.com/terms"
            target="_blank"
            rel="noopener noreferrer"
          >
            Terms &amp; Conditions
          </a>{' '}
          and{' '}
          <a
            href="https://drivepoints.com/privacy-policy/"
            target="_blank"
            rel="noopener noreferrer"
          >
            Privacy Policy
          </a>
          .
        </p>
        <div
          style={{
            display: 'flex',
            gap: '10px',
            justifyContent: 'center',
            marginTop: '1.5rem',
          }}
        >
          <Button primary onClick={() => auth.signinRedirect()}>
            <Icon name="sign-in" />
            Sign In
          </Button>
        </div>
      </Segment>
    </div>
  )
}

UserProfile.propTypes = {
  userContext: PropTypes.shape({
    globalRole: PropTypes.string,
  }),
}

export default UserProfile
